export const NPS_SURVEY_BOTTOM_SHEET_NAME = 'nps-survey-bottom-sheet';

export const NPS_COMMENT_MAX_LENGTH = 500;
